import React from 'react';
import {Loader} from 'lucide-react';

const LoadingPage = ({message, ...rest}) => (
	<div className="flex items-center justify-center h-full" {...rest}>
		<Loader strokeWidth={1} className="w-10 h-10 animate-spin duration-[2000ms]" />
		<div className="text-gray-500">{message}</div>
	</div>
);

export default LoadingPage;
